module.exports = __webpack_public_path__ + "static/media/image_graphs_home_page.910057ce.png";